/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountAgreement } from './DiscountAgreement';
import {
    DiscountAgreementFromJSON,
    DiscountAgreementFromJSONTyped,
    DiscountAgreementToJSON,
    DiscountAgreementToJSONTyped,
} from './DiscountAgreement';

/**
 * 
 * @export
 * @interface DiscountAgreements
 */
export interface DiscountAgreements {
    /**
     * 
     * @type {number}
     * @memberof DiscountAgreements
     */
    globalDiscount: number;
    /**
     * 
     * @type {Array<DiscountAgreement>}
     * @memberof DiscountAgreements
     */
    discountAgreements: Array<DiscountAgreement>;
}

/**
 * Check if a given object implements the DiscountAgreements interface.
 */
export function instanceOfDiscountAgreements(value: object): value is DiscountAgreements {
    if (!('globalDiscount' in value) || value['globalDiscount'] === undefined) return false;
    if (!('discountAgreements' in value) || value['discountAgreements'] === undefined) return false;
    return true;
}

export function DiscountAgreementsFromJSON(json: any): DiscountAgreements {
    return DiscountAgreementsFromJSONTyped(json, false);
}

export function DiscountAgreementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountAgreements {
    if (json == null) {
        return json;
    }
    return {
        
        'globalDiscount': json['globalDiscount'],
        'discountAgreements': ((json['discountAgreements'] as Array<any>).map(DiscountAgreementFromJSON)),
    };
}

export function DiscountAgreementsToJSON(json: any): DiscountAgreements {
    return DiscountAgreementsToJSONTyped(json, false);
}

export function DiscountAgreementsToJSONTyped(value?: DiscountAgreements | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'globalDiscount': value['globalDiscount'],
        'discountAgreements': ((value['discountAgreements'] as Array<any>).map(DiscountAgreementToJSON)),
    };
}

